<template>
  <a-modal :width="modalWidth"
           :style="modalStyle"
           :class="{'jeecg-onl-button-modal': true}"
           @cancel="handleCancel"
           :visible="visible">
    <template #title>
      <mtcLangPopover text="button.customButton" />
    </template>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator" style=" margin-bottom: 18px;">
      <mtc-button type="primary" @click="handleAdd" icon="plus" text="button.add" />
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div :style="table_area_style">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <span>
          <a-icon class="anticon ant-alert-icon" theme="filled" type="info-circle" />
          <!-- 已选择 -->
          <mtcLangPopover text="tip.selected" />：
          <!-- 条数 -->
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
          <!-- 单位 -->
          <mtcLangPopover text="tip.term" />
          <mtcLangPopover text="button.clear">
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
          </mtcLangPopover>
        </span>
      </div>
      <a-table ref="table"
               size="middle"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               @change="handleTableChange">
        <!-- 表头自定义渲染 -->
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" />
        </template>
        <span slot="action" slot-scope="text, record">
          <mtcLangPopover text="button.edit">
            <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
          </mtcLangPopover>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              <mtcLangPopover text="button.more" />
              <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <onlCgformButton-modal :code="code" ref="modalForm" @ok="modalFormOk" />
    <template #footer>
      <mtc-button key="back" @click="handleCancel" text="button.close" />
      <div v-if="aiTestMode" style="display: inline-block;float:left">
        <mtc-button @click="genButtons(code)" text="button.generateTestData" />
      </div>
    </template>
  </a-modal>
</template>

<script>
import OnlCgformButtonModal from './OnlCgformButtonModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { AiTestOnlineMixin } from '@/views/modules/aitest/onlinetest.mixins'

export default {
  name: 'OnlCgformButtonList',
  mixins: [JeecgListMixin, AiTestOnlineMixin],
  components: {
    OnlCgformButtonModal
  },
  data() {
    return {
      modalWidth: '100%',
      modalStyle: {
        'top': 0,
        'padding': 0,
        'height': (window.innerHeight - 5) + 'px',
        'overflow-y': 'hidden'
      },
      table_area_style: {
        'height': (window.innerHeight - 210) + 'px',
        'overflow-y': 'auto'
      },
      visible: false,
      description: '自定义按钮管理页面',
      code: '',
      url: {
        list: '/online/cgform/button/list/',
        delete: '/online/cgform/button/delete',
        deleteBatch: '/online/cgform/button/deleteBatch'
      },
      isorter: {
        column: 'orderNum',
        order: 'asc'
      },
      // 表头
      columns: [
        {
          slotName: 'tableHeader.buttonCode',
          scopedSlots: { customRender: 'buttonCode', title: 'tableHeader.buttonCode' },
          align: 'center',
          dataIndex: 'buttonCode'
        },
        {
          slotName: 'tableHeader.buttonName',
          scopedSlots: { customRender: 'buttonName', title: 'tableHeader.buttonName' },
          align: 'center',
          dataIndex: 'buttonName'
        },
        {
          slotName: 'tableHeader.buttonStyle',
          scopedSlots: { customRender: 'buttonStyle', title: 'tableHeader.buttonStyle' },
          align: 'center',
          dataIndex: 'buttonStyle',
          customRender: (text, row) => {
            if (text === 'form') {
              let p = row.optPosition
              return text + '(' + (p == '2'? '底部': '侧面') + ')'
            } else {
              return text
            }
          }
        },
        {
          slotName: 'tableHeader.buttonType',
          scopedSlots: { customRender: 'optType', title: 'tableHeader.buttonType' },
          align: 'center',
          dataIndex: 'optType'
        },
        {
          slotName: 'tableHeader.sort',
          scopedSlots: { customRender: 'orderNum', title: 'tableHeader.sort' },
          align: 'center',
          dataIndex: 'orderNum'
        },
        {
          slotName: 'tableHeader.buttonIcon',
          scopedSlots: { customRender: 'buttonIcon', title: 'tableHeader.buttonIcon' },
          align: 'center',
          dataIndex: 'buttonIcon'
        },
        {
          slotName: 'tableHeader.expression',
          scopedSlots: { customRender: 'exp', title: 'tableHeader.expression' },
          align: 'center',
          dataIndex: 'exp'
        },
        {
          slotName: 'tableHeader.buttonState',
          scopedSlots: { customRender: 'buttonStatus', title: 'tableHeader.buttonState' },
          align: 'center',
          dataIndex: 'buttonStatus',
          customRender: function(text) {
            if (text == 1) {
              return '激活'
            } else {
              return '未激活'
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    //this.code = this.$route.params.code

  },
  methods: {
    loadData(arg) {
      if (!this.code) {
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams()//查询条件
      getAction(this.url.list + this.code, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.code = ''
    },
    show(code) {
      this.code = code
      this.visible = true
      this.loadData(1)
    }
  }
}
</script>

<style lang="less" scoped>
.jeecg-onl-button-modal {
  /deep/ .ant-modal-wrap {
    overflow: hidden;
  }
}

// 兼容1.6.2版本的antdv全屏
/deep/ .ant-modal {
  top: 0;
  padding: 0;
}
</style>
